// use module.exports to allow importing webpack.config.common
module.exports = {
  apiKey: 'AIzaSyB56mvn2GRbFmiD_seuvGwDOzdkqLvFoIw',
  authDomain: 'auth.fitbeat.com',
  databaseURL: 'https://bold-azimuth-196305.firebaseio.com',
  projectId: 'bold-azimuth-196305',
  storageBucket: '',
  messagingSenderId: '156358306145'
};
